import { Text, type TextProps } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface TProps extends TextProps {
  tid?: string
  values?: Record<string, unknown>
}

export function T({ tid, values, children, ...textProps }: TProps) {
  const { t } = useTranslation()
  if (tid) {
    return <Text {...textProps}>{t(tid, values as Record<string, string>)}</Text>
  }
  return <Text {...textProps}>{children}</Text>
}
